import { Component, OnInit, Inject } from '@angular/core';

import { TechModalDialogResendModel } from './techmodaldialogresend.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tech-TechModalDialogResend',
  templateUrl: './techmodaldialogresend.component.html',
  styleUrls: ['./techmodaldialogresend.component.scss'],
})
export class TechModalDialogResendComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TechModalDialogResendComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TechModalDialogResendModel
  ) {}

  ngOnInit() {}

  goOut(): void {
    this.dialogRef.close();
  }
}
